<template>
  <div class="multi-select">
    <div class="title" v-if="title">{{title}}</div>
    <ul class="list">
      <li class="item" :class="{active: isAllSelected}" @click="handleAllClick">{{allSelectedText}}</li>
      <li class="item" :class="{active:selectedList.indexOf(item.text) > -1, disabled: item.isDisabled}" v-for="(item, idx) in items" :key="idx" @click="handleItemClick(item)">{{item.text}}<span v-if="!item.isRead&&title==='负面'" class="isRead"></span></li>
    </ul>
  </div>
</template>
<script>
/*
  props: 

  title: 选项标题
  items: 是数组类型，包含所有选项

  事件:

  change 参数：包含所有选中的条目
  
*/

export default {
  data() {
    return {
      isAllSelected: false,
      isRead: true,
      selectedList: []
    };
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    allSelectedText: {
      type: String,
      default: '全部'
    },
    selectedFilters: {
      type: Array
    }
  },
  watch: {
    'selectedFilters'(newval) {
      if (!newval.length) {
        this.isAllSelected = false;
      }
      this.selectedList = newval;
    }
  },
  methods: {
    handleItemClick(item) {
      if (!item.isDisabled) {
        this.isAllSelected = false;
        if (this.selectedList.indexOf(item.text) < 0) {
          this.selectedList.push(item.text);
        } else {
          this.selectedList.splice(this.selectedList.indexOf(item.text), 1);
        }
        if (this.selectedList.indexOf(this.allSelectedText) > -1) {
          this.selectedList.splice(0, 1);
        }
        this.$emit('change', { selectedList: this.selectedList, isReadId: item.id });
      }
    },
    handleAllClick() {
      this.isAllSelected = !this.isAllSelected;
      this.selectedList = [];
      if (this.isAllSelected) {
        this.$emit('change', { selectedList: [this.allSelectedText] });
      } else {
        this.$emit('change', { selectedList: [] });
      }
    }
  },
  mounted() {
    this.selectedList = this.selectedFilters;
  }
};
</script>
<style lang="scss" scoped>
$titleColor: #fff;
$itemDefaultTextColor: #ccc;
$itemActiveBgColor: #262429;
$itemActiveColor: #5ac8ff;
$itemHoverColor: #5ac8ff;
ul, li {
  margin: 0;
  padding: 0;  
  list-style: none;
}
.multi-select {
  display: flex;
  .title {
    min-width: 72px;
    height: 32px;
    line-height: 32px;
    align-items: center;
    padding: 0 8px;
    font-weight: 600;
    font-size: 14px;
    color: $titleColor;
  }
  ul.list {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    li {
      height: 24px;
      margin: 4px 4px;
      padding: 2px 6px;
      font-size: 14px;
      color: $itemDefaultTextColor;
      border-radius: 4px;
      cursor: pointer;
      .isRead {
        display: inline-block;
        margin-bottom: 9px;
        width: 6px;
        height: 6px;
        background-color: #fe4954;
        border-radius: 50%;
      }
      &:hover {
        color: $itemHoverColor;
      }
      &.active {
        background-color: $itemActiveBgColor;
        color: $itemActiveColor;
      }
      &.disabled {
        color: #666666;
        &:hover {
          color: #666666;
        }
        cursor: not-allowed;
      }
    }
  }
}
</style>
